import { VoucherType } from '@/providers'

export type BettingFlowType = 'direct' | 'printed'

export const getPaymentType = (
    voucherType: VoucherType | null,
    bettingFlow?: string
): string => {
    switch (voucherType) {
        case 'betting':
            return bettingFlow === 'direct' ? '40' : '30'
        case 'gaming':
            return '20'
        case 'ips':
            return '20' // TODO: Update ips with proper payment type value
        default:
            return '20'
    }
}

export const VOUCHER_TYPE_MAPPING = {
    STANDARD_VOUCHER: 'Bet Vaučer',
    NON_BETTING_VOUCHER: 'Digital Vaučer',
    TERMINAL_BETTING_VOUCHER: 'Bet Vaučer',
    gaming: 'Digital Vaučer',
    betting: 'Bet Vaučer',

    '10': 'Bet Vaučer',
    '20': 'Digital Vaučer',
    '30': 'Bet Vaučer',
    '40': 'Bet Vaučer'
} as const
